import { AddressCard } from "components/AddressCard";
import { CardWithImage } from "components/slices/CardWithImage";
import { ContactForm } from "components/ContactForm";
import { EXTRALARGE, WHITE } from "shared/variables";
import { getSingle } from "shared/prismic";
import { Intro } from "components/Intro";
import { MaxWidth } from "components/MaxWidth";
import { OverlapArea } from "components/OverlapArea";
import { Page } from "components/Page";
import { RichText } from "components/slices/RichText";
import { SpacingSection } from "components/SpacingSection";
import styles from "./contact.module.css";

export async function getStaticProps({ preview = null, previewData }) {
  const doc = await getSingle({ previewData, type: "contact" });
  return { props: { doc, preview } };
}

const Contact = ({ doc, preview }) => {
  const {
    card_link_label,
    card_link,
    card_text,
    card_title,
    intro,
    seo_description,
    seo_image,
    seo_title,
  } = doc.data;

  const renderCardWithImage =
    card_link || card_link_label || card_text || card_title;

  return (
    <Page
      title={seo_title}
      description={seo_description}
      image={seo_image}
      preview={preview}
    >
      <OverlapArea noOverlap>
        <MaxWidth>
          <Intro color={WHITE} title="Contact" text={intro} />
        </MaxWidth>
      </OverlapArea>
      <SpacingSection size={EXTRALARGE}>
        <MaxWidth size={EXTRALARGE}>
          <div className={styles.flexContainer}>
            <AddressCard />
            <div>
              {renderCardWithImage && (
                <div className={styles.cardContainer}>
                  <CardWithImage
                    link={card_link}
                    linkLabel={card_link_label}
                    text={card_text}
                    title={card_title}
                  />
                </div>
              )}

              <RichText>
                <h2>Contactformulier</h2>
              </RichText>

              <ContactForm />
            </div>
          </div>
        </MaxWidth>
      </SpacingSection>
    </Page>
  );
};

export default Contact;
